import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-analytics-bar-chart',
  templateUrl: './analytics-bar-chart.component.html',
  styleUrls: ['./analytics-bar-chart.component.scss']
})
export class AnalyticsBarChartComponent implements OnChanges {
  @Input() chartTitle: string = '';
  @Input() data: any = {};
  @Input() barColor: string = '#1976d2';
  @Input() yAxisLabels: string[] = ['0.0', '1.0', '2.0', '3.0', '4.0', '5.0'];
  @Input() isDynamic: boolean = false;
  @Input() maxScale: number = 5;

  public Number = Number;
  chartData: {key: string, value: number}[] = [];
  maxValue: number = 5;

  ngOnChanges(changes: SimpleChanges) {
    if ((changes['data'] && this.data)) {
      this.prepareChartData();
      this.updateYAxis();
    }
  }

  private prepareChartData() {
    const entries = [];
    if (Array.isArray(this.data)) {
      this.data.forEach(item => {
        entries.push({
          key: item.key,
          value: Number(item.value)
        });
      });
    } else {
      for (const key in this.data) {
        if (this.data.hasOwnProperty(key)) {
          entries.push({
            key: key,
            value: Number(this.data[key])
          });
        }
      }
    }
    this.chartData = entries;
  }

  private updateYAxis() {
    if (this.isDynamic) {
      const maxVal = Math.max(...this.chartData.map(d => d.value), this.maxScale);
      this.maxValue = Math.ceil(maxVal / 5) * 5; // Round up to nearest 5 for cleaner steps
      
      const steps = 5;
      const labels = [];
      for (let i = 0; i <= steps; i++) {
        labels.push((this.maxValue / steps * i).toFixed(0));
      }
      this.yAxisLabels = labels;
    } else {
      this.maxValue = this.maxScale;
      // Keep provided or default yAxisLabels for fixed scale
    }
  }
}